import { render, staticRenderFns } from "./nav-investment-entity-list.vue?vue&type=template&id=8cb76cf2&scoped=true&"
import script from "./nav-investment-entity-list.vue?vue&type=script&lang=ts&"
export * from "./nav-investment-entity-list.vue?vue&type=script&lang=ts&"
import style0 from "./nav-investment-entity-list.vue?vue&type=style&index=0&id=8cb76cf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb76cf2",
  null
  
)

export default component.exports